module.exports = __webpack_public_path__ + "static/media/floor.4b4cfb47.png";